import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { GoogleMapsLoaderService } from '../../../core/services/address/google-maps/google-maps.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import {
  debounceTime,
  switchMap,
  distinctUntilChanged,
  catchError,
} from 'rxjs/operators'
import { AsyncPipe, JsonPipe, NgForOf } from '@angular/common'
import { map, Observable, of } from 'rxjs'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { MatDivider } from '@angular/material/divider'
import { MatProgressBar } from '@angular/material/progress-bar'

@Component({
  selector: 'modal-google-maps',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatOption,
    MatSelect,
    MatAutocompleteModule,
    AsyncPipe,
    NgForOf,
    JsonPipe,
    MatDivider,
    MatProgressBar,
  ],
  templateUrl: './modal-google-maps.component.html',
  styleUrl: './modal-google-maps.component.scss',
  standalone: true,
  providers: [GoogleMapsLoaderService],
})
export class ModalGoogleMapsComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private googleMapsLoaderService: GoogleMapsLoaderService,
    private serviceTypeService: ServiceTypeService,
    private dialogRef: MatDialogRef<ModalGoogleMapsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @Output() response = new EventEmitter()

  form: FormGroup = new FormGroup({})

  formMaps: FormGroup = new FormGroup({})

  loading = false
  loadingGoogle = false

  filteredOptions$!: Observable<any[]>

  ngOnInit(): void {
    this.createForm()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: [''],
      postalCode: [{ value: '', disabled: true }],
      street: [{ value: '', disabled: true }],
      neighborhood: [{ value: '', disabled: true }],
      number: [''],
      complement: [''],
      country: [{ value: '', disabled: true }],
      state: [{ value: '', disabled: true }],
      city: [{ value: '', disabled: true }],
      latitude: [{ value: '', disabled: true }],
      longitude: [{ value: '', disabled: true }],
    })

    this.formMaps = this.formBuilder.group({
      location: [''],
    })

    this.filteredOptions$ = this.formMaps.get('location')!.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((query) => {
        return this.searchGoogle(query)
      }),
    )
  }

  createModel(value: any) {
    return {
      input: value ?? '',
      languageCode: 'pt-BR',
      regionCode: 'BR',
    }
  }

  onOptionSelected(event: any): void {
    this.loadingGoogle = true
    this.formMaps.get('location')?.setValue(event.option.value.description)
    // this.form.get('description')?.setValue('')
    // this.form.get('description')?.setValue(event.option.value.description)
    this.detailsGoogle(event.option.value)
    // this.detailsGoogle(event.option.value.id)
  }

  searchGoogle(query: string): Observable<any[]> {
    if (!query || query.length < 3) {
      return of([])
    }

    // return this.serviceTypeService.searchServiceType(query).pipe(
    return this.googleMapsLoaderService
      .autocomplete(this.createModel(query))
      .pipe(
        map((response: any) => {
          const list: any[] = []
          for (let i = 0; i < response.suggestions.length; i++) {
            const element = response.suggestions[i]
            if (
              element.placePrediction.placeId &&
              element.placePrediction.text.text
            ) {
              list.push({
                id: element.placePrediction.placeId,
                description: element.placePrediction.text.text,
              })
            }
          }
          return list
        }),
        catchError((err) => {
          console.error('Erro ao buscar:', err)
          return of([]) // garante que sempre retorna array
        }),
      )
  }

  // searchGoogle(value: any) {
  //   this.googleMapsLoaderService
  //     .autocomplete(this.createModel(value))
  //     .subscribe({
  //       next: (response: any) => {
  //
  //         this.detailsGoogle('ChIJ_2UYIGNJxwcRH4FygqPNdy0')
  //       },
  //       error: (err: ResponseRequestModel) => {
  //         console.error(err)
  //       },
  //       complete: () => {},
  //     })
  // }

  // detailsGoogle(placeId: string) {
  detailsGoogle(selected: any) {
    this.googleMapsLoaderService.getPlaceDetails(selected.id).subscribe({
      next: (response: any) => {
        this.fillAdress(response)
        this.form.get('description')?.setValue('')
        this.form.get('description')?.setValue(selected.description)
        this.loadingGoogle = false
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
        this.loadingGoogle = false
      },
      complete: () => {
        this.loadingGoogle = false
      },
    })
  }

  clearForm() {
    this.form.get('description')?.setValue('')
    this.form.get('postalCode')?.setValue('')
    this.form.get('street')?.setValue('')
    this.form.get('neighborhood')?.setValue('')
    this.form.get('number')?.setValue('')
    this.form.get('complement')?.setValue('')
    this.form.get('country')?.setValue('')
    this.form.get('state')?.setValue('')
    this.form.get('city')?.setValue('')
    this.form.get('latitude')?.setValue('')
    this.form.get('longitude')?.setValue('')
  }

  fillAdress(detail: any) {
    if (detail.addressComponents) {
      for (let i = 0; i < detail.addressComponents.length; i++) {
        const element = detail.addressComponents[i]
        if (element.types) {
          if (element.types.includes('route')) {
            this.form.get('street')?.setValue(element.longText)
          } else if (element.types.includes('postal_code')) {
            this.form.get('postalCode')?.setValue(element.longText)
          } else if (element.types.includes('street_number')) {
            this.form.get('number')?.setValue(element.longText)
          } else if (
            element.types.includes('sublocality_level_1', 'sublocality')
          ) {
            this.form.get('neighborhood')?.setValue(element.longText)
          } else if (element.types.includes('country')) {
            this.form.get('country')?.setValue(element.longText)
          } else if (element.types.includes('administrative_area_level_1')) {
            this.form.get('state')?.setValue(element.longText)
          } else if (element.types.includes('administrative_area_level_2')) {
            this.form.get('city')?.setValue(element.longText)
          } else if (element.types.includes('plus_code')) {
            this.form.get('complement')?.setValue(element.longText)
          }
        }
      }
      // if(this.form.get('description')?.value != ''){
      // this.form.get('description')?.setValue(detail.displayName.text)
      // }
      this.form.get('longitude')?.setValue(detail.location.longitude)
      this.form.get('latitude')?.setValue(detail.location.latitude)
    }
  }

  insertAddress() {
    this.response.emit({ insert: true, model: this.createModelInsert() })
    this.close()
  }

  close() {
    this.dialogRef.close()
  }

  createModelInsert() {
    return {
      cep: this.form.get('postalCode')?.value ?? '',
      logradouro: this.form.get('street')?.value ?? '',
      numero: this.form.get('number')?.value ?? '',
      bairro: this.form.get('neighborhood')?.value ?? '',
      complemento: this.form.get('complement')?.value ?? '',
      estado: this.form.get('state')?.value ?? '',
      cidade: this.form.get('city')?.value ?? '',
      pais: this.form.get('country')?.value ?? '',
      latitude: this.form.get('latitude')?.value ?? '',
      longitude: this.form.get('longitude')?.value ?? '',
      descricao: this.form.get('description')?.value ?? '',
    }
  }
}
